<template>
  <v-btn
    color="primary"
    variant="text"
    @click="$router.back()"
    :dir="$i18n.locale === 'he' ? 'rtl' : 'ltr'"
  >
    <v-icon :right="$i18n.locale === 'he'" :left="$i18n.locale !== 'he'">
      {{ $i18n.locale === "he" ? "mdi-arrow-right" : "mdi-arrow-left" }}
    </v-icon>
    {{ $t("back") }}
  </v-btn>
</template>
<script>
export default {
  name: "AlertBackButton",
};
</script>
